import {dateFormatter, integerFormatter, numberFormatter} from "../../gridFormatters";

export const backupStatus = [
    {
        "field": "backup_job_name",
        "headerName": "Job Name",
        "enableRowGroup": true,
        "filter": "agSetColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "protected_objects",
        "headerName": "Protected Objects",
        "suppressColumnsToolPanel": true,
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "protected_space",
        "headerName": "Protected Space (GiB)",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "type": "numericColumn",
        "cellRenderer": numberFormatter
    },
    {
        "field": "retention",
        "headerName": "Retention (Days)",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "errors",
        "headerName": "Errors",
        "enableRowGroup": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "status",
        "headerName": "Status",
        "enableRowGroup": true,
        "filter": "agSetColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        // "cellRenderer": integerFormatter
    },
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter,
        "enableRowGroup": true,
        "hide": true,
    },
];